import { BucketUnit, ChartSeries, MultiSeriesAreaChart } from "@nova/component-charts"
import { NovaSpinner } from "@nova/component-nova-spinner"

const unitLabels: Record<BucketUnit, string> = {
    hour: "Events per hour",
    day: "Events per day",
    week: "Events per week",
    month: "Events per month",
}

export const ActivityChartSection = ({
    series,
    unit,
    isLoading,
}: {
    series: ChartSeries[]
    unit: BucketUnit
    isLoading: boolean
}) => (
    <div className="flex flex-col gap-3">
        <h5 className="text-gray-400">{unitLabels[unit]}</h5>
        <div className="h-[260px] w-full flex items-center justify-center">
            {isLoading ? (
                <NovaSpinner width={16} height={16} />
            ) : (
                <MultiSeriesAreaChart series={series} unit={unit} />
            )}
        </div>
    </div>
)
